import { Skeleton, Space } from 'antd';
import { useRouter } from 'next/router';
import { useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import GrispiInput from '../../components/GrispiInput/index';
import useEndUserFormById from '../../hooks/end-user-form/useEndUserFormById';
import { transformFieldRuleOnForm } from '../../hooks/ticketDetailPage/useAgentFormById';
import { pushTo } from '../../utils/routeHelper';
import { FORM_FIELD_KEY } from '../Pages/TicketPages/TicketPagesContentLayout/AgentFormActiveFieldsContainer';
import EndUserFormActiveFieldsContainer from './EndUserFormActiveFieldsContainer';

const EndUserRequestFieldsContainer = () => {
    const { t } = useTranslation('forms');
    const {
        query: { userFormId }
    } = useRouter();

    const { data: selectedForm, isLoading, error } = useEndUserFormById(userFormId?.toString());

    const watchedFormId = useWatch({ name: FORM_FIELD_KEY });
    const currentAgentForm = transformFieldRuleOnForm(selectedForm);

    return (
        <Space direction="vertical" size="middle" className="full-width">
            {isLoading ? (
                <>
                    <Skeleton.Input active size="small" />
                    <Skeleton.Input active className="full-width" />
                </>
            ) : (
                <GrispiInput
                    antdProps={{
                        allowClear: false,
                        placeholder: t('endUserForm.formId.placeholder')
                    }}
                    containerProps={{
                        label: t('endUserForm.formId.label'),
                        extra: !userFormId && t('endUserForm.formId.helperText'),
                        errorMessage: userFormId && error && t('endUserForm.formId.errorText')
                    }}
                    onChange={(formId) => pushTo(`/requests/user-forms/${formId}`)}
                    type="FORM"
                    value={watchedFormId}
                    isEndUserForm
                />
            )}

            <EndUserFormActiveFieldsContainer form={currentAgentForm} />
        </Space>
    );
};
export default EndUserRequestFieldsContainer;
